import * as initialDataTypes from '../types/InitialData';
import {INITIAL_STATE} from './state/InitialData';

export default function (state = INITIAL_STATE, action) {
    switch(action.type) {
        case initialDataTypes.GET_INITIAL_DATA_FAILURE:
            return {
                ...state,
                isLoading: false,
                error: action.error
            };
        case initialDataTypes.GET_INITIAL_DATA_REQUEST:
            return {
                ...state,
                isLoading: true,
                error: null
            };
        case initialDataTypes.GET_INITIAL_DATA_SUCCESS:
            return {
                ...state,
                isLoading: false
            };
    }
    return state;
}


// WEBPACK FOOTER //
// ./src/reducers/InitialData.js